var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "win-layer-pop",
        { staticClass: "common-booking" },
        [
          _vm.commonBkgComponent
            ? _c(_vm.commonBkgComponent, {
                tag: "component",
                attrs: { "parent-info": _vm.commonBkgPopParams },
                on: {
                  close: _vm.commonBkgClosePopup,
                  selectFunc: _vm.commonBkgSelectFunc,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }